import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import PageHeader from "@/components/PageHeader";
import { Stagger, staggerItem } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { useSeo } from "@/lib/seo";
import { useBrand } from "@/context/SiteContext";
import { SOLUTIONS, SERVICES_LIST, brandify } from "@/data/content";

export default function Solutions() {
  const brand = useBrand();
  useSeo({ title: "Solutions & Services | Solar EPC, Rooftop, B2B & Government Supply", description: "Solar EPC, rooftop solar, commercial & industrial solar, solar + battery storage, UPS solutions, government & institutional supply, B2B dealer & EPC supply and BOS supply.", canonical: `https://${brand.domain}/solutions` });
  return (
    <div>
      <PageHeader label="Solutions & Services" title="End-to-End Solar, Storage & Power Services" sub="From turnkey EPC and rooftop solar to B2B supply, government supply and after-sales support — solutions engineered around your actual requirement." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SOLUTIONS.map((s) => (
            <motion.div key={s.slug} variants={staggerItem}>
              <Link to={`/solutions/${s.slug}`} data-testid={`solution-card-${s.slug}`} className="card-surface block overflow-hidden group h-full">
                <div className="h-44 overflow-hidden"><img src={s.image} alt={s.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                <div className="p-6">
                  <div className="mono-label">{s.sector}</div>
                  <div className="font-display font-semibold text-white text-lg mt-1 flex items-center justify-between">{s.name} <ArrowUpRight size={18} className="text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity" /></div>
                  <p className="text-sm text-slate-400 mt-2 line-clamp-2">{brandify(s.intro, brand.name)}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </Stagger>
        <div className="mt-12 card-surface p-8">
          <h2 className="font-display text-2xl font-bold text-white mb-4">All Services</h2>
          <div className="flex flex-wrap gap-2">{SERVICES_LIST.map((s) => <span key={s} className="badge-terminal">{s}</span>)}</div>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
